import React, { ReactNode } from 'react';

import { Column as TableColumn, ColumnProps } from 'primereact/column';

export const Column = (props: ColumnProps)=> {
  return (
      <TableColumn
        columnKey={props.columnKey}
        field={props.field}
        sortField={props.sortField}
        filterField={props.filterField}
        sortable={props.sortable}

        header={props.header}
        body={props.body}
        footer={props.footer}

        style={props.style}
        className={props.className}
        headerStyle={props.headerStyle}
        bodyStyle={props.bodyStyle}
      />
  )
}